module.exports = __webpack_public_path__ + "boiler-preferences.svg";